import useAuthSuccessCallback from './useAuthSuccessCallback'
import { selectRestPopupBody } from 'rest/restSlice'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import useEnterClick from 'hooks/useEnterClick'
import Submit from 'components/inputs/Submit'
import PinForm from 'components/PinForm'
import { useReduxSelector } from 'store'
import React, { useState } from 'react'

const CODE_LENGTH = 4

const PinPopup: React.FC = () => {

  const popupBody = useReduxSelector(selectRestPopupBody)
  const [warning, setWarning] = useState(false)
  const [token, setToken] = useState('')

  const successCallback = useAuthSuccessCallback()
  const { t } = useTranslation('auth')
  const submit = () => {
    successCallback({ success: true, token })
  }
  const getSubmitText = (l: number) => l === CODE_LENGTH
    ? t('authorize')
    : `${CODE_LENGTH - l} ${t(l === CODE_LENGTH - 1 ? 'characterIsMissing' : 'charactersAreMissing')}`

  useEnterClick(() => {
    if (token.length === 4) {
      submit()
    }
  })

  return (
    <div className='popup__pin popup__verification'>
      <div className='popup__title'>
        <div>{'title' in popupBody ? popupBody.title : t('enterYourPin')}</div>
      </div>

      {popupBody && 'verified' in popupBody && popupBody?.verified === false && <p className='verification__warning'>{t('incorrectCode')}</p>}

      <PinForm
        value={token}
        warning={warning}
        setValue={setToken}
        setWarning={setWarning}
      />

      <div className='popup__buttons'>
        <Submit
          action={submit}
          block={token.length !== 4}
          text={getSubmitText(token.length)}
        />

        <BackBtn text={t('cancel')} />
      </div>
    </div>
  )
}

export default PinPopup